/**
 * HTML Structure
 *
 *
 *

 Below Pusher

 .slide-in-on-top
 .reveal
 .slide-along
 .reverse-slide-out
 .scale-down-pusher
 .scale-up
 .scale-rotate-pusher
 .open-door
 .fall-down



 Into Pusher

 .push-down
 .rotate-pusher
 .three-d-rotate-in
 .three-d-rotate-out
 .delayed-three-d-rotate

 *
 * body
 *    .wrapper
 *        .pusher
 *            .contents
 *                .inner-contents ( html contents goes here )
 *            nav  ( off canvas menus into pusher )
 *         nav ( off canvas menus beside pusher )
 *
 *
 *
 * */


;
(function($) {
    $.fn.extend({
        HippoOffCanvasMenu: function(options) {

            this.defaultOptions = {
                documentWrapper: '.hippo-offcanvas-wrapper',
                position: 'hippo-offcanvas-left', // class name
                //opener         : 'hippo-offcanvas-open', // class name
                effect: 'slide-on-top', // class name
                contentWrapper: '.hippo-offcanvas-contents',
                closeButton: '.hippo-offcanvas-close',
                menuWrapper: '.hippo-offcanvas-container', // class name
                documentPusher: '.hippo-offcanvas-pusher'
            };

            var settings = $.extend({}, this.defaultOptions, options);

            var isMobile = function() {
                let check = false;

                if (navigator.userAgentData) {
                    check = navigator.userAgentData.mobile;
                }

                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    check = true;
                }

                return check;
            };

            return this.each(function() {

                var $this = $(this);
                var eventType = isMobile() ? 'touchstart' : 'click';

                var transitionEvent = function() {
                    var t, el = document.createElement("fakeelement");

                    var transitions = {
                        "transition": "transitionend",
                        "OTransition": "oTransitionEnd",
                        "MozTransition": "transitionend",
                        "WebkitTransition": "webkitTransitionEnd"
                    }

                    for (t in transitions) {
                        if (el.style[t] !== undefined) {
                            return transitions[t];
                        }
                    }
                }

                var animationEvent = function() {
                    var t, el = document.createElement("fakeelement");

                    var animations = {
                        "animation": "animationend",
                        "OAnimation": "oAnimationEnd",
                        "MozAnimation": "animationend",
                        "WebkitAnimation": "webkitAnimationEnd"
                    }

                    for (t in animations) {
                        if (el.style[t] !== undefined) {
                            return animations[t];
                        }
                    }
                }


                $(settings.documentWrapper)
                    .addClass('hippo-offcanvas-wrapper')
                    .addClass(settings.position)
                    .addClass(settings.effect);

                $(settings.menuWrapper).show();
                $(settings.menuWrapper).addClass('hippo-offcanvas-container');
                $(settings.documentPusher).addClass('hippo-offcanvas-pusher');
                $(settings.contentWrapper).addClass('hippo-offcanvas-contents');

                $(this).on(eventType, function(event) {

                    event.stopPropagation();
                    event.preventDefault();
                    $(this).addClass('hippo-offcanvas-button-opened');
                    $(settings.documentWrapper).addClass('hippo-offcanvas-open');
                    $('html').addClass('hippo-offcanvas-html-open');
                    $('body').addClass('hippo-offcanvas-body-open');
                });

                $(settings.closeButton).on(eventType, function(event) {

                    event.stopPropagation();
                    event.preventDefault();
                    $this.removeClass('hippo-offcanvas-button-opened');
                    $(settings.documentWrapper).removeClass('hippo-offcanvas-open');

                    $(settings.menuWrapper).one(transitionEvent(), function(e) {
                        $('html').removeClass('hippo-offcanvas-html-open');
                        $('body').removeClass('hippo-offcanvas-body-open');
                    });

                    $(settings.menuWrapper).one(animationEvent(), function(e) {
                        $('html').removeClass('hippo-offcanvas-html-open');
                        $('body').removeClass('hippo-offcanvas-body-open');

                    });
                });

                $(document).on(eventType, function(event) {

                    if (!$(event.target).parents().hasClass('hippo-offcanvas-container')) {

                        $this.removeClass('hippo-offcanvas-button-opened');
                        $(settings.documentWrapper).removeClass('hippo-offcanvas-open');

                        $(settings.menuWrapper).one(transitionEvent(), function(e) {
                            $('html').removeClass('hippo-offcanvas-html-open');
                            $('body').removeClass('hippo-offcanvas-body-open');
                        });

                        $(settings.menuWrapper).one(animationEvent(), function(e) {
                            $('html').removeClass('hippo-offcanvas-html-open');
                            $('body').removeClass('hippo-offcanvas-body-open');
                        });
                    }
                });

            });
        }
    });
})(jQuery);